import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { PNS_INBOX_URL } from '../../../commons/Utils/UrlBuilder'
import { NotificationPreviewPopup, NotificationPreviewPopupNonLogin } from './Popup'
import { useFetch } from '../../../commons/Hooks/useFetch'
import { useOutsideClick } from '../../../commons/Hooks/useOutsideClick'

export function NotificationPreviewButton({ isLoggedIn, token }) {
  const popupRef = useRef(null)
  const [visible, setVisible] = useState(false)
  useOutsideClick(popupRef, () => { setVisible(false) })

  const showPopup = () => {
    !visible ? setVisible(true) : setVisible(false)
  }

  const notificationIcon = 'notification-preview-button__icon-show'

  if (!isLoggedIn) {
    return (
      <div ref={popupRef}>
        <button
          onClick={showPopup}
          className={`notification-preview-button ${notificationIcon}`}
        />
        {visible ? <NotificationPreviewPopupNonLogin /> : null}
      </div>
    )
  }

  const config = { headers: { Authorization: `Bearer ${token}`} }
  const { data, error, loaded } = useFetch(PNS_INBOX_URL, config)

  if (!loaded || error) {
    return null
  }

  return (
    <div ref={popupRef}>
      <button
        onClick={showPopup}
        className={`notification-preview-button ${notificationIcon}`}
      />
      {data.has_unseen_notifications && (
        <div className="notification-preview-button__icon-unread" />
      )}
      {visible ? <NotificationPreviewPopup data={data} /> : null}
    </div>
  )
}

NotificationPreviewButton.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  token: PropTypes.string.isRequired
}
